// extracted by mini-css-extract-plugin
export var editInput = "_hx-0";
export var editInputCompact = "_hx-2";
export var editInputLarge = "_hx-1";
export var editInputSmall = "_hx-3";